import axios from "axios";
import { GET_ALL_SERVICE_PRODUCT, GET_ALL_SERVICE_PRODUCT_FAILED, GET_ALL_SERVICE_PRODUCT_SUCCESS, GET_BILLING_INFO, GET_BILLING_INFO_FAILED, GET_BILLING_INFO_SUCCESS, GET_SERVICE_DATA, GET_SERVICE_DATA_FAILED, GET_SERVICE_DATA_SUCCESS } from "../../constants/storeConstant";

export  const GetAllServiceProduct = () => async(dispatch) => {
            dispatch({type: GET_ALL_SERVICE_PRODUCT});
        try {
            const res = await axios.get("/store/product?type=premium_service");
            dispatch({type: GET_ALL_SERVICE_PRODUCT_SUCCESS, payload: res.data});

        } catch(error) {
            dispatch({type: GET_ALL_SERVICE_PRODUCT_FAILED, payload: error.message});
        }
}


export  const GetBillingInfo = () => async(dispatch) => {
    dispatch({type: GET_BILLING_INFO});
try {
    const res = await axios.get("/store/finance/billing");
    dispatch({type: GET_BILLING_INFO_SUCCESS, payload: res.data});

} catch(error) {
    dispatch({type: GET_BILLING_INFO_FAILED, payload: error.message});
}
}

export  const GetServiceData = () => async(dispatch) => {
    dispatch({type: GET_SERVICE_DATA});
try {
    const res = await axios.get("/store/product?type=premium_service");
    dispatch({type: GET_SERVICE_DATA_SUCCESS, payload: res.data});

} catch(error) {
    dispatch({type: GET_SERVICE_DATA_FAILED, payload: error.message});
}
}